// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M11.4329 13.8237L12 14.2136L12.5676 13.8233L12.569 13.8223L12.573 13.8196L12.5853 13.811L12.6263 13.7819C12.6608 13.7573 12.7092 13.7222 12.7696 13.6772C12.8902 13.5873 13.0592 13.4573 13.2604 13.2917C13.6614 12.9617 14.1981 12.484 14.738 11.8935C15.7821 10.7515 17 9.01233 17 7C17 4.23858 14.7614 2 12 2C9.23858 2 7 4.23858 7 7C7 9.01215 8.2179 10.7514 9.26196 11.8934C9.80183 12.4839 10.3386 12.9616 10.7395 13.2916C10.9408 13.4572 11.1097 13.5872 11.2304 13.6772C11.2907 13.7222 11.3392 13.7573 11.3736 13.7819L11.4147 13.811L11.4269 13.8195L11.4309 13.8223L11.4329 13.8237ZM12 8.5C11.1716 8.5 10.5 7.82843 10.5 7C10.5 6.17157 11.1716 5.5 12 5.5C12.8284 5.5 13.5 6.17157 13.5 7C13.5 7.82843 12.8284 8.5 12 8.5Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M7 10H2V22H22V10H17V12H18.5858L13.982 16.6037L13.0941 15.5889L11.5889 16.9059L14.2962 20H5.27323L9.91288 14.9386L8.43857 13.5871L4 18.4292V12H7V10ZM15.302 18.1122L20 13.4142V20H16.9538L15.302 18.1122Z"}}]};

const MapInformationFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'map-information-filled',
    ref,
    icon: element,
  },
));

MapInformationFilledIcon.displayName = 'MapInformationFilledIcon';

export default MapInformationFilledIcon;
